import React, { useState, createContext, useContext, HTMLAttributes, FC } from 'react';
import styles from './Accordion.module.scss';
import Icon from '@/components/UI/icon/Icon';
type AccordionContextProps = {
  isOpen: boolean;
  toggle: () => void;
};
const AccordionContext = createContext<AccordionContextProps>({
  isOpen: false,
  toggle: () => {}
});
interface AccordionProps extends HTMLAttributes<HTMLDivElement> {
  Title?: FC<HTMLAttributes<HTMLDivElement>>;
  Content?: FC<HTMLAttributes<HTMLDivElement>>;
  expanded?: boolean;
  data_cy?: string;
}
const Accordion = ({
  children,
  expanded = false,
  data_cy,
  ...props
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(expanded);
  const toggle = () => setIsOpen(prev => !prev);
  return <AccordionContext.Provider value={{
    isOpen,
    toggle
  }} data-sentry-element="unknown" data-sentry-component="Accordion" data-sentry-source-file="Accordion.tsx">
      <div data-cy={data_cy} {...props}>
        {children}
      </div>
    </AccordionContext.Provider>;
};
const Title: FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  className = '',
  ...props
}) => {
  const {
    isOpen,
    toggle
  } = useContext(AccordionContext);
  return <div {...props} className={`${styles['accordion-header']} ${className}`} onClick={toggle} data-sentry-component="Title" data-sentry-source-file="Accordion.tsx">
      <div className={styles['accordion-label']}>{children}</div>
      <div className={`${styles['accordion-icon']} ${isOpen ? styles['open'] : styles['close']}`}>
        <Icon name={'arrow-down-1'} type={'highEmphasis'} size={'large'} data-sentry-element="Icon" data-sentry-source-file="Accordion.tsx" />
      </div>
    </div>;
};
const Content: FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => {
  const {
    isOpen
  } = useContext(AccordionContext);
  return <div className={`${styles['accordion-content']} ${isOpen ? styles['open'] : styles['close']}`} data-sentry-component="Content" data-sentry-source-file="Accordion.tsx">
      <div {...props}>{children}</div>
    </div>;
};
Accordion.Title = Title;
Accordion.Content = Content;
export default Accordion;